import React, { useState } from 'react'

import { Link, useLocation, useNavigate } from 'react-router-dom'

import style from './Header.module.css'

import { ReactComponent as InfoIcon } from 'assets/icons/info-icon.svg'
import { ReactComponent as StatsIcon } from 'assets/icons/stats-icon.svg'
import logoImage from 'assets/images/logo.svg'
import { IconButton, BasicModal } from 'common/components'
import { Paths } from 'common/routes'
import { ResetButton } from 'features/dashboard'

export const Header = () => {
  const location = useLocation()
  const [isShowInfo, setIsShowInfo] = useState(false)
  const navigate = useNavigate()

  return (
    <header className={style.header}>
      <div className={`container ${style.box}`}>
        <div className={style.logo}>
          <Link to="/">
            <img src={logoImage} alt="logo" />
          </Link>
        </div>
        <div className={style['button-box']}>
          <IconButton
            callback={() => navigate(Paths.Info)}
            title="Статистика"
            disabled={location.pathname === Paths.Info}
          >
            <StatsIcon className={style['info-icon']} />
          </IconButton>
          {location.pathname === Paths.Info && <ResetButton />}
          <IconButton callback={() => setIsShowInfo(true)} title="О приложении">
            <InfoIcon className={style['info-icon']} />
          </IconButton>
        </div>
      </div>

      <BasicModal title="О приложении" isOpen={isShowInfo} onClose={() => setIsShowInfo(false)}>
        <div className={style['info-content']}>
          <p>Тренируйся печатать код быстро и наблюдай за своим прогрессом!</p>
          <p>
            Для тренировок представлены фрагменты кода на основных языках и технологиях, которые
            используются в веб-разработке.
          </p>
          <ul className={style['features-list']}>
            <li>
              Горячие клавиши:
              <ul className={style['nested-list']}>
                <li> Alt/Option + Enter (проверка кода)</li>
              </ul>
            </li>
            <li>
              Результаты тренировок сохраняются в local storage. При очищении браузерного кеша,
              результаты сбросятся
            </li>
          </ul>
        </div>
      </BasicModal>
    </header>
  )
}
